import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FC } from 'react';

import { Link } from '@mui/material';
import { observer } from 'mobx-react-lite';

const LogInStep: FC = observer(() => {
  const url = 'https://mein.vav.at/login';
  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mt: 2, mb: 3, fontWeight: 'bold' }}>
        Bei Ihrer Haushaltsversicherung einloggen
      </Typography>

      <Typography sx={{ mb: 2 }}>
        Sie haben Ihren Antrag bereits abgeschickt? Perfekt! Loggen Sie sich
        jetzt bei VAV ein, um den aktuellen Status Ihrer Versicherung zu prüfen.
      </Typography>

      <Typography sx={{ mb: 2 }}>
        Im Kundenportal können Sie jederzeit Ihre Vertragsdaten einsehen,
        Dokumente herunterladen oder Änderungen vornehmen.
      </Typography>

      <Link
        href={url}
        target="_blank"
        rel="noopener noreferrer"
        sx={{ fontSize: '1.1rem', fontWeight: 500 }}
      >
        Zum VAV Kundenportal
      </Link>

      <Typography
        variant="caption"
        sx={{ display: 'block', mt: 3, color: 'text.secondary' }}
      >
        Sie werden zur Login-Seite von VAV weitergeleitet. Verwenden Sie die
        Zugangsdaten, die Sie bei der Registrierung erhalten haben.
      </Typography>
    </Box>
  );
});

export default LogInStep;
